export default "__VITE_ASSET__lhaqzVpa__"